import { all } from 'redux-saga/effects';
import getPolicyDetail from './getPolicyDetail';
import getInsuranceType from './getInsuranceType';

export const policySagas = function* root() {
  yield all([getPolicyDetail(), getInsuranceType()]);
};
